<template>
    <div id="app">
        <!-- <v-touch v-on:swiperight="onSwipeRight" :swipe-options="{direction: 'horizontal', threshold: 50}" class="full-wrapper"> -->
        <!--threshold 设置左右滑动的距离-->

        <transition :name="transitionName">
            <keep-alive :include="cacheList">
                <router-view></router-view>
            </keep-alive>
        </transition>
        <!-- <transition v-if="$route.meta.keepAlive" :name="transitionName">
            <keep-alive>
                <router-view></router-view>
            </keep-alive>
        </transition>

        <transition v-if="!$route.meta.keepAlive" :name="transitionName">
            <router-view></router-view>
        </transition> -->

        <!-- </v-touch> -->
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import routers from "@/router/module";
export default {
    name: "app",
    data() {
        return {
            // transitionName: window.navigator.userAgent.indexOf('innoApp') > -1 ? 'slide-left' : ''
            transitionName: "slide-left",
        };
    },
    computed: {
        cacheList() {
            let navList = this.$store.state.app.navList;
            const list = navList.length ? navList.filter((item) => item.meta && item.meta.keepAlive).map((item) => item.name) : [];
            return list;
        },
    },
    watch: {
        //全局监听路由变化
        $route(to, from) {
            // console.log(to.path.split("/"));
            //页面切换动效
            let routerArr = (sessionStorage.getItem("routers") && sessionStorage.getItem("routers").split(",")) || [];
            // console.log(routerArr);/
            if (routerArr.length == 0) {
                routerArr.push(from.path);
                routerArr.push(to.path);
            } else {
                if (routerArr.indexOf(to.path) != -1) {
                    this.transitionName = "slide-right";
                    routerArr.splice(routerArr.indexOf(to.path) + 1, 100);
                } else {
                    this.transitionName = "slide-left";
                    routerArr.push(to.path);
                }
            }
            sessionStorage.setItem("routers", routerArr.join(","));
        },
    },
    created() {
        //在页面加载时读取sessionStorage里的状态信息
        if (sessionStorage.getItem("store")) {
            this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))));

            sessionStorage.removeItem("store");
        }

        //在页面刷新时将vuex里的信息保存到sessionStorage里
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("store", JSON.stringify(this.$store.state));
        });
    },
    mounted() {
        this.setNavList(routers);
    },
    methods: {
        ...mapMutations(["setNavList"]),

        /**
         * 右滑手势
         */
        // onSwipeRight(){
        //     mui.nativeBack && mui.nativeBack();
        // }
    },
};
</script>
<style lang="less" scoped>
#app {
    width: 100%;
    -webkit-overflow-scrolling: touch; // 处理苹果滑动卡顿效果
    /*overflow-x: hidden;*/
    /*transform: scale(.5);
       transform-origin: center 0; */
    height: 100vh;
    overflow-x: hidden;
    background: #f5f8fa;
}
/*.appView {
	  position: absolute;
	  width:100%;
	  transition: transform 0.3s;
	  height: 100vh;
	}*/

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
    position: absolute;
    top: 0;
    width: 100%;
    transition: transform 0.4s;
}

.slide-left-enter {
    transform: translate3d(100%, 0, 0);
}

.slide-left-leave-active {
    transform: translate3d(-100%, 0, 0);
}

.slide-right-enter {
    transform: translate3d(-100%, 0, 0);
}

.slide-right-leave-active {
    transform: translate3d(100%, 0, 0);
}

.full-wrapper {
    min-height: 100vh;
    & > div {
        height: 100vh;
        overflow-y: auto;
    }
}
</style>
